import { CadModelCategory } from "@api/apiClient";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import AppStore from "@stores/AppStore";
import { MutableRefObject } from "react";
import { parseMultiplier } from "./multiplier";

export const setSelectedNodesKeys = (
  apiRef: MutableRefObject<GridApiPremium>,
  cadModelCategories: CadModelCategory[],
  appStore: AppStore) => {
  const selectedModelCategories: any = {};
  const selectedNodesKeys: any = {};
  const selectedRows = apiRef.current.getSelectedRows();

  selectedRows.entries().forEach(([key, value]) => {
    if (value.type === "category") {
      if (cadModelCategories.find((category: CadModelCategory) => category.cadModelCategoryId === value?.data.cadModelCategoryId)) {
        selectedModelCategories[key] = value;
      }
    }
  });

  selectedRows.values().forEach((value) => {
    if (value.leaf) {
      const key = value.data.componentId ?? value.data.elementId;
      selectedNodesKeys[key] = value;
    }
  });

  appStore.setSelectedModelCategories(selectedModelCategories);
  appStore.setSelectedNodesKeys(selectedNodesKeys);
};

export const validateModelRow = (row: any) => {
  const errors: Record<string, string> = {};

  // Notes: max 250 chars
  if (row?.data?.notes && row.data.notes.length > 250) {
    errors.notes = "Notes cannot exceed 250 characters.";
  }

  // Multiplier: must be empty or parseable
  const input = row?.data?.multiplierInput ?? "";
  const parsed = parseMultiplier(input);
  if (input.trim() !== "" && parsed === null) {
    errors.multiplierInput = "Invalid multiplier. Use %, number, or formula.";
  }

  // Carbon Impact: must be empty or parseable (same rules as multiplier)
  const carbonInput = row?.data?.carbonImpactInput ?? "";
  const parsedCarbon = parseMultiplier(carbonInput);
  if (carbonInput.trim() !== "" && parsedCarbon === null) {
    errors.carbonImpactInput = "Invalid carbon impact. Use %, number, or formula.";
  }
  // CarbonImpactNotes: max 250 chars
  if (row?.data?.carbonImpactNotes && row.data.carbonImpactNotes.length > 250) {
    errors.carbonImpactNotes = "Notes cannot exceed 250 characters.";
  }

  return errors;
};